
import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import EventBus from '../../../eventBus'
import { required } from "vuelidate/lib/validators";
import { Validations } from 'vuelidate-property-decorators';

@Component
export default class ManageNPT extends Vue {
    @Validations()
    validations = {
        npt: {
            name: { required }
        }
    }
    activeScreen: string = 'main'
    loadingMessage: string = 'Please wait while we create new NPT'
    loadingTitle: string = 'Saving...'
    additionalSuccessMessage: string = ''
    successMessage: string = 'New NPT Created Successfully'
    links: Array<object> = [
        {
            text: 'NPT Operations',
            to: '/operations'
        },
        {
            text: 'Manage NPT Operation',
            active: true
        }
    ]
    index: any = null
    error: any = {
        generalMessage: '',
        errors: []
    }
    npt: any = {
        nptCategory: "",
        rootCauses: "",
    }
    activeItem: any = null
    nptTypes: any = []
    formErrors: string[] = []

    checkErrors() {
        this.formErrors = []
        if (this.npt.nptCategory.length < 1) {
            this.formErrors.push("NPT Category is required")
        }
    }

    @Watch('nptSettings', { immediate: true })
    onNPTSettingsFetch() {
        this.nptTypes = this.nptSettings.map((setting: any) => ({ text: setting.nptCategory, value: setting.nptCategory }))
    }

    update() {
        this.activeScreen = 'loading'
        EventBus.$emit('activeScreen', this.activeScreen);
        this.loadingMessage = 'Please wait while we update this NPT operation';
        this.loadingTitle = 'Updating NPT Operation';
        var payload = this.createPayload()
        this.$store.dispatch('nptModule/updateNPTOperation', payload)
            .then((response: any) => {
                this.activeScreen = 'successNoGotIt';
                EventBus.$emit('activeScreen', this.activeScreen);
                this.additionalSuccessMessage = '';
                this.successMessage = 'NPT Operation Updated Successfully';
            }).catch((error: any) => {
                this.activeScreen = 'error'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.error = error
            })
    }

    saveNew() {
        this.activeScreen = 'loading'
        EventBus.$emit('activeScreen', this.activeScreen);
        this.loadingMessage = 'Please wait while we save this NPT operation';
        this.loadingTitle = 'Saving NPT Operation';
        var payload = this.createPayload()
        this.$store.dispatch('nptModule/createNptOperation', payload)
            .then((response: any) => {
                this.activeScreen = 'successRemain';
                EventBus.$emit('activeScreen', this.activeScreen);
                this.additionalSuccessMessage = '';
                this.successMessage = 'Successfully Created ' + payload.nptCategory;
            }).catch((error: any) => {
                this.activeScreen = 'error'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.error = error
            })
    }

    persistData() {
        if (this.activeItem == null)
            this.saveNew();
        else
            this.update();
    }

    get fetchNptSettings() {
        return this.$store.dispatch('settingsModule/getNptSettings')
    }

    get nptSettings() {
        return this.$store.getters['settingsModule/getNptSettings']
    }

    get getNPTById() {
        return this.$store.getters['nptModule/getNptById']
    }
    get checkNTPType(): boolean {
        if (!this.npt.nptType) {
            return false
        } else {
            return true
        }
    }
    get isButtonDisabled(): boolean {
        if (this.formErrors.length > 0) {
            return true
        } else {
            return false
        }
    }

    get rootCauseOptions(): Array<any> {

        const setting = this.nptSettings.find((setting: any) => setting.nptCategory === this.npt.nptCategory)
        if (!setting) return []

        return setting.rootCauses.map((cause: string) => ({ value: cause, text: cause }))
    }

    createPayload() {
        return {
            id: this.activeItem ? this.activeItem.id : 0,
            nptCategory: this.npt.nptCategory,
            rootCauses: this.npt.rootCauses,
        };
    }

    created() {
        this.fetchNptSettings
        if (!this.$route.query) {
            this.checkErrors()
        } else {
            this.activeItem = this.getNPTById(this.$route.query.id)
            if (!this.activeItem) {
                this.checkErrors()
            } else {
                this.npt.nptCategory = this.activeItem.nptCategory;
                this.npt.rootCauses = this.activeItem.rootCauses;
            }
        }
    }
}
